export default __webpack_public_path__ + "static/media/leankit.0a996492.svg";